/** Contrat tableau de bord — payload `dashboard.php`. */

export type KpiId = "overdue" | "upcoming" | "paid_month" | "quotes";

export type DashPage = "invoices" | "quotes" | "credits" | "recurring" | "payments";

export type DashTarget = {
  page: DashPage;
  id?: number;
  /** Filtre de liste : overdue, upcoming, relance, expired, soon, month. */
  filter?: string;
};

export type DashKpi = {
  id: KpiId;
  label: string;
  hint: string;
  value: string;
  tone?: "default" | "warn";
  bar?: number;
  open?: DashTarget;
};

export type DashQueueItem = {
  id: string;
  title: string;
  meta: string;
  open?: DashTarget;
};

export type DashActivityItem = {
  id: string;
  kind: "payment" | "invoice" | "credit" | "reminder" | "recurring";
  title: string;
  meta: string;
  open?: DashTarget;
};

export type DashCollected = {
  current_ht_cents: number;
  previous_ht_cents: number;
};

export type DashMailDay = {
  day: string;
  label: string;
  sent: number;
  failed: number;
  failed_numbers: string[];
};

export type DashBillingMonth = {
  key: "prev" | "current" | "next";
  label: string;
  amount: string;
  detail: string;
};

export type DashBillingDay = {
  day: string;
  label: string;
  count_label: string;
  amount: string;
  detail: string;
};

export type DashBilling = {
  months: DashBillingMonth[];
  upcoming_title: string;
  days: DashBillingDay[];
};

export type DashRealized = {
  month_label: string;
  month_range: string;
  month_imported?: boolean;
  month_prev_label: string;
  month_prev_range: string;
  month_prev_imported?: boolean;
  month_ly_label: string;
  month_ly_range: string;
  month_ly_imported?: boolean;
  year_label: string;
  year_range: string;
  year_imported?: boolean;
  year_prev_label: string;
  year_prev_range: string;
  year_prev_imported?: boolean;
  month_ca_ht_cents: number;
  month_vat_cents: number | null;
  month_prev_ca_ht_cents: number;
  month_prev_vat_cents: number | null;
  month_ly_ca_ht_cents: number;
  month_ly_vat_cents: number | null;
  year_ca_ht_cents: number;
  year_vat_cents: number | null;
  year_prev_ca_ht_cents: number;
  year_prev_vat_cents: number | null;
};

export type DashPayload = {
  kpis: DashKpi[];
  overdue: DashQueueItem[];
  upcoming: DashQueueItem[];
  quotes: DashQueueItem[];
  recurring: DashQueueItem[];
  activity: DashActivityItem[];
  mail_days?: DashMailDay[];
  billing?: DashBilling;
  realized?: DashRealized;
  collected?: DashCollected;
};

export const EMPTY_KPIS: DashKpi[] = [
  { id: "overdue", label: "En retard", hint: "Factures validées, échéance dépassée", value: "—", tone: "warn", open: { page: "invoices", filter: "overdue" } },
  { id: "upcoming", label: "À encaisser", hint: "Factures envoyées, pas encore échues", value: "—", open: { page: "invoices", filter: "upcoming" } },
  { id: "paid_month", label: "Encaissé ce mois", hint: "Somme des paiements", value: "—", open: { page: "payments", filter: "month" } },
  { id: "quotes", label: "Devis à relancer", hint: "Expirés ou bientôt expirés", value: "—", open: { page: "quotes", filter: "relance" } },
];
